





















































import { Component, Vue, Prop } from "vue-property-decorator";
import { namespace } from "vuex-class";
import { FileEntryModel } from "../models";
import dateFlip from "shared/filters/dateflip";

const opStore = namespace("relationprofile");

@Component({
  filters: { dateFlip },
})
export default class AddressBlock extends Vue {
  @Prop({ required: false, type: Boolean, default: false })
  showProjects!: boolean;

  @opStore.Getter fileEntries!: FileEntryModel[];
  @opStore.Action fetchFileEntries!: () => Promise<void>;

  get headers(): { text: string; value: string; sortable?: boolean }[] {
    let base: { text: string; value: string; sortable?: boolean }[] = [];
    if (this.showProjects) {
      base = [{ text: this.t("project"), value: "project" }];
    }
    return [
      ...base,
      { text: this.t("category"), value: "category" },
      { text: this.t("description"), value: "description" },
      { text: this.t("archive_date"), value: "archive_date" },
      { text: "", value: "", sortable: false },
    ];
  }

  private search = "";
  private selectedCategories: string[] = [];

  get categories(): string[] {
    return this.fileEntries.map((f: FileEntryModel) => f.category).sort();
  }

  get filtered(): FileEntryModel[] {
    let filtered = this.fileEntries;
    if (this.search !== "") {
      filtered = this.fileEntries.filter((f: FileEntryModel) =>
        f.description.toLowerCase().includes(this.search.toLowerCase())
      );
    }
    if (this.selectedCategories.length > 0) {
      filtered = this.fileEntries.filter((f: FileEntryModel) =>
        this.selectedCategories.includes(f.category)
      );
    }
    return filtered;
  }

  private pagination = {
    descending: true,
    sortBy: "archive_date",
  };

  private t(key: string): string {
    return this.$t("relationprofile.tables.files." + key).toString();
  }

  private mounted() {
    this.fetchFileEntries();
    (this.$refs.fileListTooltip as Element).parentElement!.className =
      "tooltip-container";
  }
}
